module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8x1ip"))).then(() => parcelRequire('d0iPb'));